const forgotPasswordFormConstantsAR = {
  forgotPasswordFormTitle: 'نسيت رقمك السري؟',
  forgotPasswordFormSubTitle:
    'سنرسل رمزًا لإعادة تعيين كلمة المرور الخاصة بك إلى البريد الإلكتروني المرتبط بحساب موجود.',
  forgotPasswordFormButtonText: "ارسال بريد اعادة تعيين كلمة السر",
  forgotPasswordFeildLabel: 'البريد الإلكتروني',
  resetPasswordEmailSentSnackBar : 'تم ارسال رسالة اعادة تعيين كلمة المرور'
};

export default forgotPasswordFormConstantsAR;
